import React from 'react'
import { CenteredRow } from './Components'
import LoadingAnimation from './LoadingAnimation'

const CenteredLoadingAnimation = (props) => (
  <CenteredRow css={{ alignSelf: 'center', justifySelf: 'center' }}>
    <LoadingAnimation {...props} />
  </CenteredRow>
)

export default CenteredLoadingAnimation
